var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{attrs:{"id":"comp"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('text'))}}),_c('button',{on:{"click":function($event){return _vm.hide()}}},[_vm._v("Ok")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }